import styled from "styled-components";
import {ButtonLabelPaddingDefaultBox} from "./button-label-padding.default.box";

export const ButtonLabelPaddingSIBox = styled(ButtonLabelPaddingDefaultBox)`
    padding-top: 0em;
    padding-bottom: 0.1em;

    @media ${({theme}) => theme.mediaQuery.xlExact} {
        padding-bottom: ${({sizeVariant}) => sizeVariant === "xs" ? "0em" : "0.1em" };
    }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding-bottom: 0;
    }
`;